import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../../shared/http-utils';
import {URL_BASE} from '../../core/constants';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {BluechatSearchCriteria} from './bluechat-search-criteria.model';
import { LoadManagementSearchDto } from './load-management-search-response';
import {BluechatLoad, BluechatLoadStatus} from './bluechat-load.model';

@Injectable()
export class LoadManagementService {

  private BLUECHAT_URI = 'loads/management';

  constructor(private http: HttpClient, private authService: AuthenticationService) {}

  public search(bluechatSearchCriteria: BluechatSearchCriteria): Observable<LoadManagementSearchDto> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/${this.BLUECHAT_URI}/${this.getRoleSpecificUriPart()}`;
    const params = bluechatSearchCriteria.toQueryParams();

    return this.http.get(url, { headers, params }).pipe(
      map((response: any) => LoadManagementSearchDto.fromDto(response)),
    );
  }

  public getById(loadNumber: string): Observable<BluechatLoad> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/${this.BLUECHAT_URI}/${loadNumber}`;

    return this.http.get(url, { headers }).pipe(
      map((response: any) => BluechatLoad.fromDto(response)),
    );
  }

  private getRoleSpecificUriPart() {
    if (this.authService.canViewAllLoadsManagement() ) {
      return 'search';
    } else {
      return 'search/by/carrier/self';
    }
  }

  public doesLoadStatusAllowsNoteCreation(status: BluechatLoadStatus) {
    return status !== BluechatLoadStatus.OPEN
      && status !== BluechatLoadStatus.PLANNED
      && status !== BluechatLoadStatus.TENDERED
      && status !== BluechatLoadStatus.TENDER_REJECTED;
  }
}
